"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeReseller_en_us = void 0;
function backofficeReseller_en_us() {
    return {
        "backoffice.reseller.companies.title": "Companies",
        "backoffice.reseller.projects.title": "Projects",
        "backoffice.reseller.users.title": "Users",
        "backoffice.reseller.subscriptions.title": "Subscriptions",
        "backoffice.reseller.bookedsubscriptions.title": "Booked Subscriptions"
    };
}
exports.backofficeReseller_en_us = backofficeReseller_en_us;
